import { defineComponent } from 'vue';
import { ElLoading } from 'element-plus';
import Layout from '@/components/Layout.vue';
import GrasshopperTabs from "@/views/GrasshopperTabs";
import { get_toolset_categories } from "@/service/api";
import { get_toolset_name_from_full_path } from "@/utils/path";
export default defineComponent({
  name: 'Home',
  components: {
    Layout,
    GrasshopperTabs
  },
  setup() {
    const openFullScreenLoading = () => {
      return ElLoading.service({
        lock: true,
        text: 'Loading'
      });
    };
    return {
      openFullScreenLoading
    };
  },
  data() {
    return {
      categories: []
    };
  },
  computed: {},
  watch: {},
  async created() {
    const loading = this.openFullScreenLoading();
    let toolsetName = get_toolset_name_from_full_path(this.$route.path);
    await get_toolset_categories(toolsetName).then(result => {
      this.categories = result.data;
      loading.close();
    });
  }
});